module.exports = __webpack_public_path__ + "img/Logo-16.a3171693.svg";